export const style = {
  buttonEdit: {
    sx: {
      '&:hover': {
        backgroundColor: 'primary.main',
      },
    },
  },
  CardActions: {
    boxDelete: {
      sx: {
        width: '100%',
      },
    },
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      gap: 15,
      margin: '0px 16px',
    },
  },
  card: {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    CardContent: {
      minHeight: 450,
      width: '100%',
      flex: 1,
      position: 'relative',
      mb: 0,
      pb: 0,
    },
    circular: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    divider: {
      sx: {
        my: 2,
      },
    },
    row: {
      sx: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      },
    },
    box: {
      sx: {
        mb: 2,
      },
    },
    header: {
      height: 84,
      backgroundColor: 'primary.main',
      color: '#fff',
      position: 'sticky',
      top: '0',
      zIndex: 2,
    },
    headerRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    drawler: {
      flexShrink: 0,
      position: 'absolute',
      overflow: 'auto',
      '& .MuiPaper-root.MuiPaper-elevation': {
        overflow: 'auto',
        borderRadius: 0,
      },
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        zIndex: 2,
        top: 80,
        width: 480,
        overflow: 'scroll',
        height: 'calc(100vh - 80px)',
      },
    },
  },
} as const;
